import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractBinaryOperatorFormulaToken from "./AbstractBinaryOperatorFormulaToken.js";
import MultiplicationFormulaNode from "../formula/MultiplicationFormulaNode.js";

/**
 * Binary operation token representing a mathematical multiplication.
 */
export default class MultiplicationFormulaToken extends AbstractBinaryOperatorFormulaToken {
	precedence() {
		return 1;
	}

	accept(visitor) {
		return visitor.visitMultiplicationFormulaToken(this);
	}

	_formulaNodeConstructor() {
		return MultiplicationFormulaNode;
	}

	static getLabel() {
		return _("Multiplication");
	}

	static getType() {
		return "multiplication";
	}
}
